import React, { useState, useEffect,useRef } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Modal,
  ThemeProvider,
  Box,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ButtonWithCheckBox from "./ResponseMenu";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export default function FormCard({
  index,
  serialNumber = index,
  view = false,
  edit = false,
  question = {},
  setQuestions = () => {},
  selectedLanguage="english",
  setSelectedLanguage= () => {},
}) {
  const language_keys = Object.keys(question).filter(
    (key) => key !== "response_type" && key !== "id" && key!=='responses' && !key.startsWith("response_")
  );
  const languages = [
        ...new Set(
          language_keys.concat([
            "english",
            "hindi",
            "punjabi",
            "marathi",
            "gujarati",
            "tamil",
            "telugu",
            "kannada",
            "odia",
          ])
        ),
      ]
  const [responseTypeList, setResponseTypeList] = useState([
    "audio",
    "text",
    "image",
    "dropdown",
    "radio"
  ]);
  const [responseTypePointer, setResponseTypePointer] = useState(
    responseTypeList.indexOf(question["response_type"])
  );
  const [selectedResponseType, setSelectedResponseType] = useState(
    question["response_type"]
  );
  const [languagePointer, setLanguagePointer] = useState(0);
  const [selectedQuestion, setSelectedQuestion] = useState(
    question[selectedLanguage]
  );
  const [editing, setEditing] = useState(false);
  const [editedText, setEditedText] = useState(selectedQuestion);
  const [responsesLanguageWise, setResponsesLanguageWise] = useState(() => {
    const initialResponses = question.responses || {};
    const allLanguages = [
      "english",
      "hindi",
      "punjabi",
      "marathi",
      "gujarati",
      "tamil",
      "telugu",
      "kannada",
      "odia",
    ];
  
    const initializedResponses = {};
    allLanguages.forEach((language) => {
      if (
      ( question.response_type === "DROPDOWN" || question.response_type === "RADIO")&&
        question[`response_${language}`]
      ) {
        initializedResponses[language] = question[
          `response_${language}`
        ].split(",").map((value) => value.trim());
      } else {
        initializedResponses[language] = initialResponses[language] || [];
      }
    });
  
    return initializedResponses;
  });
const [anchorElResponses, setAnchorElResponses] = useState(null);

useEffect(()=>{
  setResponseTypePointer(responseTypeList.indexOf(question["response_type"]))
  setSelectedResponseType(question["response_type"])
  setSelectedQuestion(question[selectedLanguage])
},[question])

useEffect(()=>{
  if(selectedResponseType.toUpperCase() === "DROPDOWN" || selectedResponseType.toUpperCase() === "RADIO"){
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[index] = {
        ...updatedQuestions[index],
        responses: responsesLanguageWise,
      };
      return updatedQuestions;
    });
  }
 
},[responsesLanguageWise])

  const handleChangeBack = () => {
    if (languagePointer > 0) {
      setLanguagePointer(languagePointer - 1);
      setSelectedLanguage(languages[languagePointer - 1]);
    }
  };

  const handleChangeForward = () => {
    if (languagePointer < languages.length - 1) {
      setLanguagePointer(languagePointer + 1);
      setSelectedLanguage(languages[languagePointer + 1]);
    }
  };
  const handleChangeForwardResponseType = () => {
    if (responseTypePointer < responseTypeList.length - 1) {
      setResponseTypePointer(responseTypePointer + 1);
      setSelectedResponseType(responseTypeList[responseTypePointer + 1]);
    }
  };
  const handleChangeBackResponseType = () => {
    if (responseTypePointer > 0) {
      setResponseTypePointer(responseTypePointer - 1);
      setSelectedResponseType(responseTypeList[responseTypePointer - 1]);
    }
  };
  const handleDelete = () => {
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions.splice(index, 1);
      return updatedQuestions;
    });
  };
  const handleEditToggle = () => {
    setEditing(true);
  };
  const handleTextChange = (event) => {
    setEditedText(event.target.value);
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[index][selectedLanguage] = event.target.value;
      return updatedQuestions;
    });
  };
  const handleBlur = () => {
    setEditing(false);
    setSelectedQuestion(editedText);
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[index][selectedLanguage] = editedText;
      return updatedQuestions;
    });
  };

  useEffect(() => {
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[index]["response_type"] = selectedResponseType;
      return updatedQuestions;
    });
  }, [selectedResponseType]);

  useEffect(() => {
    setEditing(false);
    setSelectedQuestion(
      question[selectedLanguage] ? question[selectedLanguage] : ""
    );
  }, [selectedLanguage]);

  useEffect(() => {
    setEditedText(selectedQuestion);
  }, [selectedQuestion]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const handleClickResponses = (event) => {
    setAnchorElResponses(event.currentTarget);
  };

  const handleCloseResponses = () => {
    setAnchorElResponses(null);
  };

  return (
    <Grid
    item
    xs={12}
    sm={12}
      sx={{
        padding: 2,
        marginLeft: 1,
        marginTop: 3,
        borderRadius: "1rem",
        width: "80%",
        backgroundColor: "#F5F5F5",
        overflowX: 'auto'
      }}
    >
      <Grid item xs={12} sm={12} sx={{ display: "flex" }}>
        <Box sx={{ marginRight: 1 }}>
          <strong>{serialNumber + 1}.&nbsp;</strong>
        </Box>
        <TextField
          variant="standard"
          size="small"
          value={editedText}
          onChange={handleTextChange}
          onBlur={handleBlur}
          multiline
          fullWidth
          sx={{
            color: "#444444",
          }}
          InputProps={{
            disableUnderline: true,
          }}
          disabled={view}
          autoFocus
          error={editedText !== undefined && editedText.trim() === ""}
          helperText={
            editedText !== undefined && editedText.trim() === ""
              ? "This field is empty"
              : ""
          }
        />
      </Grid>
      <Grid item xs={12} sm={12} sx={{ display: "flex",overflowX: 'auto','&::-webkit-scrollbar': { width: '8px' } }}>
        <Box
          sx={{
            paddingX: 2,
            paddingY: 1,
            marginLeft: 2,
            marginTop: 2,
            borderRadius: "0.5rem",
            backgroundColor: "#FFFFFF",
            display: "flex",
            minWidth: "300px",
            // flexDirection: { md: "column", lg: "row" }, // Set to column on xs (extra small) screen sizes and row on sm (small) and larger sizes
            alignItems: "center", // Align items in the center vertically
            // justifyContent: "space-between", 
          }}
        >
          <Box sx={{ color: "#78828C", marginRight: 2 }}>
            <Typography>Response Type:</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {!view && 
            <IconButton
              onClick={handleChangeBackResponseType}
              disabled={responseTypePointer === 0}
              sx={{
                padding: 0,
                color: "#78828C",
                marginTop: "0.2rem",
                cursor: "pointer",
                "&:hover": { color: "#2D6A4F" },
              }}
            >
              <ArrowBackIosIcon fontSize="small" />
            </IconButton>}
            <Typography
              sx={{
                color: "#2D6A4F",
                marginRight: "0.3rem",
                textAlign: "center",
                // minWidth: "50%",
              }}
            >
              {selectedResponseType.toUpperCase()}
            </Typography>
            {!view && 
            <IconButton
              onClick={handleChangeForwardResponseType}
              disabled={responseTypePointer === responseTypeList.length - 1}
              sx={{
                padding: 0,
                color: "#78828C",
                marginTop: "0.2rem",
                cursor: "pointer",
                "&:hover": { color: "#2D6A4F" },
              }}
            >
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>}
          </Box>
        </Box>
        {(selectedResponseType.toUpperCase() === "DROPDOWN" || selectedResponseType.toUpperCase() === "RADIO") && (
          <Box
            sx={{
              paddingX: 2,
              paddingY: 1,
              marginLeft: 2,
              marginTop: 2,
              borderRadius: "0.5rem",
              backgroundColor: "#FFFFFF",
              display: "flex",
              minWidth: "300px",
              alignItems: "center",
            }}
          >
            <Box sx={{ color: "#78828C", marginRight: 2 }}>
              <Typography>Responses:</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick = {handleClickResponses}
            >
              
              <Typography
                sx={{
                  color: "#2D6A4F",
                  marginRight: "0.3rem",
                  textAlign: "center",
                  minWidth: "50%",

                }}
                
              >
                View Responses
              </Typography>
              <ArrowDropDownIcon sx={{color: "#78828C"}}/>
            </Box>
          </Box>
        )}
        {anchorElResponses!==null && <ButtonWithCheckBox
        menuList={responsesLanguageWise[selectedLanguage]}
        setMenuList={setResponsesLanguageWise}
        anchorEl ={ anchorElResponses}
        language={selectedLanguage}
        handleClose={handleCloseResponses}
        view={view}
        selectedResponseType={selectedResponseType}
        />}
        {/* <Box
          sx={{
            paddingX: 2,
            paddingY: 1,
            marginLeft: 2,
            marginTop: 2,
            borderRadius: "0.5rem",
            backgroundColor: "#FFFFFF",
            display: "flex",
            minWidth:"370px",
            alignItems: "center",
          }}
        >
          <Box sx={{ color: "#78828C", marginRight: 2 }}>
            <Typography>
              Translated in ({languages.length}) Languages
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <IconButton
                onClick={handleChangeBack}
                disabled={languagePointer === 0}
                sx={{
                  padding: 0,
                  color: "#78828C",
                  marginTop: "0.2rem",
                  cursor: "pointer",
                  "&:hover": { color: "#2D6A4F" },
                }}
              >
                <ArrowBackIosIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box>
              <Typography
                sx={{
                  color: "#2D6A4F",
                  marginRight: "0.3rem",
                  textAlign: "center",
                  minWidth: "50%",
                }}
              >
                {capitalizeFirstLetter(selectedLanguage)}
              </Typography>
            </Box>
            <Box>
              <IconButton
                onClick={handleChangeForward}
                disabled={languagePointer === languages.length - 1}
                sx={{
                  padding: 0,
                  color: "#78828C",
                  marginTop: "0.2rem",
                  cursor: "pointer",
                  "&:hover": { color: "#2D6A4F" },
                }}
              >
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </Box> */}
        {!view && (
          <Box
            sx={{
              paddingX: 2,
              paddingY: 1,
              marginLeft: 2,
              marginTop: 2,
              borderRadius: "0.5rem",
              backgroundColor: "#FFFFFF",
              display: "flex",
              justifyContent: "center",
              minHeight: "2.554rem",
              maxHeight: "2.554rem",
            }}
          >
            <DeleteIcon
              fontSize="small"
              onClick={handleDelete}
              sx={{
                color: "#ACADAD",
                cursor: "pointer",
                "&:hover": { opacity: 0.7 },
                marginTop: "0.1875rem",
              }}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  );
}
